module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_vm._v("English: Love, Czech: láska, Danish: kærlighed, Dutch: liefde, Estonian: armastus, Finnish: rakkaus, French: amour, German: die Liebe, Greek: αγάπη, Hungarian: szeretet, Icelandic: ást, Indonesian: saying, Italian: amore, Latvian: mīlestība, Lithuanian: meilė, Norwegian: kjærlighet, Polish: zamiłowanie, Portuguese: amor, Romanian: dragoste, Russian: любовь, Slovak: láska, Slovenian: ljubezen, Spanish: amor, Swedish: kärlek")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("We dedicate this book to the concept, emotion, and truth that binds each and every one of us together that is summed up by one word: love. We are lucky in this world to have found partners to share our lives.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I am fulfilled in so many ways because of you, David. Thank you for all that you are. I see your strength and vulnerability and all of the things that nobody else will ever see. You challenge me and because of that I’m compelled to be more. Your wit, sarcasm, intellect, and ability to truly understand humbles me. Your ability to communicate has taught me validation. In everything you do know I am here to support and ... love you.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("To Chris, my partner in life, I want to thank for being my support, both emotionally, physically, and in my interactions with a world I don’t always fully understand. You, I love. Your support in this endeavor of writing has been a great boon.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34bd1666","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0003.vue
// module id = 63
// module chunks = 0